export default "__VITE_ASSET__CnjeY_wW__"